import { render, staticRenderFns } from "./CompanionServiceProfile.vue?vue&type=template&id=771822b4&scoped=true&"
import script from "./CompanionServiceProfile.vue?vue&type=script&lang=js&"
export * from "./CompanionServiceProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompanionServiceProfile.vue?vue&type=style&index=0&id=771822b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771822b4",
  null
  
)

export default component.exports